import { SET_FEEDBACK_REFRESH } from './actionTypes';

export const setFeedbackRefresh = () => ({
	type: SET_FEEDBACK_REFRESH,
	payload: new Date(),
});
